var map = {
	"./Blast1.json": [
		557,
		92
	],
	"./Blast2.json": [
		558,
		93
	],
	"./Fireball.json": [
		559,
		94
	],
	"./Firework1.json": [
		560,
		95
	],
	"./Firework2.json": [
		561,
		96
	],
	"./Fireworkstart.json": [
		562,
		97
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1077;
module.exports = webpackAsyncContext;